import { render, staticRenderFns } from "./classraporu.vue?vue&type=template&id=d89640a2&"
import script from "./classraporu.vue?vue&type=script&lang=js&"
export * from "./classraporu.vue?vue&type=script&lang=js&"
import style0 from "./classraporu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports